import { BaseDTO } from './basedto';
import { PartBasicInfo } from './partbasicinfo';

export class PartInfoInProposal {
    Parts: PartBasicInfo[];
    Length: number;
    Width: number;
    Height: number;
    Weight: number;
    Material: string;
    constructor() {
        this.Parts = [];
    }
}

